<template>
  <div>
    <div v-if="!showContent" class="content-loading">
      <base-loading v-if="showItem" color="var(--default)" />
    </div>

    <div v-else>
      <base-box class="heat-map w-100">
        <l-map
          v-if="heatmap.data.length >= 0"
          :zoom="11"
          :center="heatmapCenter"
          :scroll-wheel-zoom="false"
        >
          <l-tile-layer
            :url="`https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=${googleApiStyle}`"
            attribution="<a href='https://google.com/maps'>Powered by Google</a>"
          ></l-tile-layer>
          <LeafletHeatmap
            :lat-lng="heatmap.data"
            :options="heatmap.options"
          ></LeafletHeatmap>
        </l-map>
      </base-box>

      <div class="row chart top-negative">
        <div class="col-xs-12 col-md-12 col-lg-12">
          <chart-box
            :reload-chart="reloadChart.customerGrowth"
            title="Fluxo de clientes cadastrados"
            :showChangeMonth="true"
            @changePeriod="changePeriod"
            from="customerGrowth"
            type="line"
            :chartData="charts.customerGrowth.data"
            :chartOptions="charts.customerGrowth.options"
            class="chart-labeled"
            :width="300"
            :height="300"
          />
        </div>
        <!-- <div
          class="col-xs-12 col-md-12 col-lg-4"
          :class="isMobile ? 'top-negative' : 'pl_10'"
        >
          <chart-box
            :drawer="true"
            :reload-chart="reloadChart.customerRegions"
            title="Clientes por bairro"
            :headers="['Bairro', 'Clientes']"
            :all-items="ranking.customerRegions"
            type="doughnut"
            :chart-data="charts.customerRegions.data"
            :chart-options="charts.customerRegions.options"
            class="doughnut-chart"
            :width="300"
            :height="300"
          />
        </div> -->
      </div>

      <base-box class="msg-charts">
        <base-message :design="'gold'">
          Para ver os gráficos disponíveis, vire seu celular em modo paisagem.
        </base-message>
      </base-box>

      <filter-period
        :open="drawers.filter.customerGrowth.open"
        :close="drawers.filter.customerGrowth.close"
        @filter="filterPeriod"
        :maxCustomRange="0"
        :day-filter="false"
        :year-filter="false"
        :custom-filter="false"
      />
    </div>
  </div>
</template>

<script>
// components
import BaseBox from '@/components/Box';
import ChartBox from '@/containers/ChartBox';
import BaseMessage from '@/components/Message';
import BaseLoading from '@/components/Loading';
// containers
import FilterPeriod from '@/containers/FilterPeriod';
// libs
import { LMap, LTileLayer, LMarker } from '@eluiz/vue2-leaflet';
import LeafletHeatmap from '@/containers/HeatMap';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
// api
import ApiReports from '@/api/reports';

export default {
  components: {
    BaseBox,
    ChartBox,
    BaseMessage,
    BaseLoading,
    FilterPeriod,
    LMap,
    LTileLayer,
    LMarker,
    LeafletHeatmap,
  },
  props: {
    showLoading: Boolean,
    showItem: Boolean,
  },
  data() {
    return {
      reloadChart: {
        customerGrowth: false,
        customerRegions: false,
      },
      period: {
        default: [
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ],
        customerGrowth: [
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ],
      },
      ranking: {},
      totals: {},
      heatmap: {
        data: [],
        options: {
          radius: 25,
        },
        center: [],
      },
      googleApiStyle:
        's.e%3Ag%7Cp.c%3A%23ff242f3e%2Cs.e%3Al.t.f%7Cp.c%3A%23ff746855%2Cs.e%3Al.t.s%7Cp.c%3A%23ff242f3e%2Cs.t%3A19%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A2%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A40%7Cs.e%3Ag%7Cp.c%3A%23ff263c3f%2Cs.t%3A40%7Cs.e%3Al.t.f%7Cp.c%3A%23ff6b9a76%2Cs.t%3A3%7Cs.e%3Ag%7Cp.c%3A%23ff38414e%2Cs.t%3A3%7Cs.e%3Ag.s%7Cp.c%3A%23ff212a37%2Cs.t%3A3%7Cs.e%3Al.t.f%7Cp.c%3A%23ff9ca5b3%2Cs.t%3A49%7Cs.e%3Ag%7Cp.c%3A%23ff746855%2Cs.t%3A49%7Cs.e%3Ag.s%7Cp.c%3A%23ff1f2835%2Cs.t%3A49%7Cs.e%3Al.t.f%7Cp.c%3A%23fff3d19c%2Cs.t%3A4%7Cs.e%3Ag%7Cp.c%3A%23ff2f3948%2Cs.t%3A66%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A6%7Cs.e%3Ag%7Cp.c%3A%23ff17263c%2Cs.t%3A6%7Cs.e%3Al.t.f%7Cp.c%3A%23ff515c6d%2Cs.t%3A6%7Cs.e%3Al.t.s%7Cp.c%3A%23ff17263c',
      charts: {
        defaultColor: [
          {
            backgroundColor: '#FF338220',
            borderColor: '#FF3382',
            pointBackgroundColor: '#FF3382',
          },
          {
            backgroundColor: '#2E303370',
            borderColor: '#9999996B',
            pointBackgroundColor: '#999999',
          },
        ],
        customerRegions: {
          data: {
            labels: [],
            datasets: [
              {
                borderWidth: 0,
                backgroundColor: [
                  '#ea527e',
                  '#ce4568',
                  '#ba7892',
                  '#bbb',
                  '#ddd',
                  '#eee',
                ],
                data: [],
              },
            ],
          },
          options: {
            cutoutPercentage: 62.5,
            maintainAspectRatio: false,
            responsive: true,
            legend: {
              position: 'bottom',
              fullWidth: false,
              align: 'start',
              labels: {
                boxWidth: 20,
                padding: 20,
              },
            },
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const name = data.labels[tooltipItem.index];
                  const value = data.datasets[0].data[tooltipItem.index];

                  return name === 'Sem informações'
                    ? ` ${name}`
                    : ` ${name}: ${value}`;
                },
              },
            },
          },
        },
        customerGrowth: {
          data: {
            labels: [],
            datasets: [],
          },
          options: {
            legend: {
              display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            elements: {
              line: {
                tension: 0,
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    maxTicksLimit: 16,
                  },
                  gridLines: {
                    color: '#70707061',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {},
                  gridLines: {
                    color: '#70707061',
                  },
                },
              ],
            },
            animation: {
              duration: 1000,
            },
            tooltips: {
              callbacks: {
                title() {
                  return null;
                },
                label(tooltipItem) {
                  const isPlural = parseInt(tooltipItem.value, 10) > 1;
                  const [day, month] = String(tooltipItem.label).split('/');

                  const correctMonth =
                    tooltipItem.datasetIndex === 1
                      ? parseInt(month, 10) - 1
                      : parseInt(month, 10);
                  const date = `${day}/${
                    correctMonth < 10 ? `0${correctMonth}` : correctMonth
                  }`;

                  return parseInt(tooltipItem.value, 10) === 0
                    ? ` ${date}: Nenhum cadastro`
                    : ` ${date}: ${tooltipItem.value} cadastro${
                        isPlural ? 's' : ''
                      }`;
                },
              },
            },
          },
        },
      },
      dayjs,
      drawers: {
        filter: {
          customerGrowth: {
            open: false,
            close: false,
          },
          from: 'default',
        },
      },
      filter: {
        consolidated: {
          type: 'day',
          periods: [],
        },
      },
      showContent: false,
    };
  },
  created() {
    this.filterPeriod();
  },
  methods: {
    async search() {
      const esFilter = {
        query: [
          {
            index: 'report-customers',
            type: 'aggs',
            queries: [
              {
                bool: {
                  should: [
                    {
                      match: {
                        type: 'M',
                      },
                    },
                    {
                      match: {
                        type: 'L',
                      },
                    },
                    {
                      match: {
                        type: 'F',
                      },
                    },
                  ],
                },
              },
            ],
            aggs: {
              customers_total: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(new Date('1901-01-01')).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]'
                      ),
                      to: dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                    },
                  ],
                },
              },
              customers_currently: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(this.period.customerGrowth[0]).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]'
                      ),
                      to: dayjs(this.period.customerGrowth[1]).format(
                        'YYYY-MM-DDTHH:mm:ssZ[Z]'
                      ),
                    },
                  ],
                },
                aggs: {
                  customers_per_day: {
                    date_histogram: {
                      field: 'created_at',
                      interval: 'day',
                      min_doc_count: 1,
                    },
                  },
                },
              },
              customers_previous: {
                date_range: {
                  field: 'created_at',
                  ranges: [
                    {
                      from: dayjs(this.period.customerGrowth[0])
                        .subtract(1, 'month')
                        .format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                      to: dayjs(this.period.customerGrowth[1])
                        .subtract(1, 'month')
                        .format('YYYY-MM-DDTHH:mm:ssZ[Z]'),
                    },
                  ],
                },
                aggs: {
                  customers_per_day: {
                    date_histogram: {
                      field: 'created_at',
                      interval: 'day',
                      min_doc_count: 1,
                    },
                  },
                },
              },
            },
          },
          {
            index: 'report-orders',
            type: 'aggs',
            queries: [
              {
                match: {
                  status: 4,
                },
              },
            ],
            aggs: {
              order_regions: {
                terms: {
                  field: 'delivery.region',
                },
                aggs: {
                  geolocation: {
                    top_hits: {
                      _source: {
                        includes: ['delivery.geolocation'],
                      },
                      size: 1,
                    },
                  },
                  customers: {
                    top_hits: {
                      _source: {
                        includes: ['payers.user.id'],
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      };

      const apiResponse = await ApiReports.reports(esFilter);

      this.totals.customers =
        apiResponse.data[0].customers_total.buckets[0].doc_count;
      const customerGrowth = [];

      customerGrowth.push(
        this.formatResponseDataLineChart(
          apiResponse.data[0].customers_currently.buckets[0].customers_per_day
            .buckets
        )
      );

      customerGrowth.push(
        this.formatResponseDataLineChart(
          apiResponse.data[0].customers_previous.buckets[0].customers_per_day
            .buckets
        )
      );

      this.charts.customerGrowth.options.scales.yAxes[0].ticks.min = 0;

      this.formatDataLineChart(customerGrowth, 'customerGrowth', 'day');

      this.ranking.customerRegions =
        apiResponse.data[1].order_regions.buckets.map((item) => {
          let customersRegionsValue = 0;
          item.customers.hits.hits[0]._source.payers.forEach((payer) => {
            if (payer.user.id) {
              customersRegionsValue += 1;
            }
          });

          return {
            name: item.key,
            value: customersRegionsValue,
            geolocation: item.geolocation.hits.hits[0]._source.delivery
              ? item.geolocation.hits.hits[0]._source.delivery.geolocation
              : [-25.4573827, -49.2877663],
          };
        });

      this.setHeatMap();
      this.setChartsData('customerRegions');

      switch (this.drawers.filter.from) {
        case 'customerGrowth':
          this.reloadChart.customerGrowth = !this.reloadChart.customerGrowth;
          break;
        default:
          this.reloadChart.customerGrowth = !this.reloadChart.customerGrowth;
          this.reloadChart.customerRegions = !this.reloadChart.customerRegions;
          break;
      }

      this.$forceUpdate();
    },
    setChartsData(param) {
      const labels = this.handleChartData(
        this.ranking[param].map((item) => item.name),
        'labels'
      );
      const values = this.handleChartData(
        this.ranking[param].map((item) => item.value),
        'values'
      );
      // atualiza labels
      this.charts[param].data.labels = labels.filter((label, i) =>
        i <= 4 ? label : ''
      );
      // atualiza valores
      let othersValue = 0;
      this.charts[param].data.datasets[0].data = values.filter((value, i) => {
        if (i <= 4) return value;
        othersValue += value;
      });

      if (this.ranking[param].length === 0) {
        this.charts[param].data.datasets[0].backgroundColor = ['#ccc'];
      } else {
        this.charts[param].data.labels.push('Outros');
        this.charts[param].data.datasets[0].data.push(othersValue);
      }
    },
    handleChartData(data, type) {
      let transformedData = data;

      if (!data || data.length === 0) {
        transformedData = type === 'values' ? [-1] : ['Sem informações'];
      }

      return transformedData;
    },
    setHeatMap() {
      this.heatmap.data = [];
      this.ranking.customerRegions.forEach((item) => {
        this.heatmap.data.push([
          item.geolocation[0],
          item.geolocation[1],
          item.value,
        ]);
      });
    },
    formatDataLineChart(data, name, type) {
      this.charts[name].data.datasets = [];
      const labelChart = [];

      for (let y = 0; y < 2; y++) {
        const dataOrderChart = [];
        for (
          let i = 1;
          i <= dayjs(this.period[name][0]).subtract(y, 'month').daysInMonth();
          i++
        ) {
          if (y == 0) {
            labelChart.push(
              `${i.toString().padStart(2, '0')}/${dayjs(this.period[name][0])
                .subtract(y, 'month')
                .format('MM')}`
            );
          }

          this.charts[name].data.datasets.push;
          dataOrderChart.push(0);
        }

        this.charts[name].data.labels = labelChart;
        this.charts[name].data.datasets.push({
          label: dayjs(this.period[name][0])
            .subtract(y, 'month')
            .format('MMMM'),
          data: dataOrderChart,
          borderWidth: 1,
          backgroundColor: this.charts.defaultColor[y].backgroundColor,
          borderColor: this.charts.defaultColor[y].borderColor,
          pointBackgroundColor:
            this.charts.defaultColor[y].pointBackgroundColor,
        });
      }

      if (data) {
        data.forEach((item, idx) => {
          const dataOrderChart = [];
          let total = 0;

          if (item.length > 0) {
            for (let i = 1; i <= dayjs(item[0].date).daysInMonth(); i++) {
              dataOrderChart.push(0);
            }

            item.forEach((b) => {
              dataOrderChart[parseInt(dayjs(b.date).utc().format('D')) - 1] =
                b.count;
              total += b.count;
            });

            this.charts[name].data.datasets[idx].data = dataOrderChart;
          }

          this.charts[name].data.datasets[idx].label += ` (${total})`;
        });
      }
    },
    formatResponseDataLineChart(data) {
      return data.map((item) => ({
        date: item.key,
        date_as_string: item.key_as_string,
        count: item.doc_count,
      }));
    },
    changePeriod(chart) {
      this.drawers.filter.from = chart || 'default';
      this.drawers.filter[chart].open = !this.drawers.filter[chart].open;
    },
    async filterPeriod(filter = false) {
      const from = this.drawers.filter.from || 'default';
      this.filter.consolidated.periods[from] = [];
      // insere data de início e fim do mês
      if (!filter) {
        this.filter.consolidated.periods[from].push([
          dayjs().format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().format('YYYY-MM')}-${dayjs().daysInMonth()} 23:59:59`,
        ]);
        this.filter.consolidated.periods[from].push([
          dayjs().subtract(1, 'month').format('YYYY-MM-[01] 00:00:00'),
          `${dayjs().subtract(1, 'month').format('YYYY-MM')}-${dayjs()
            .subtract(1, 'month')
            .daysInMonth()}`,
        ]);
      } else {
        // se filtro é passado usa ele e calcula menos 1 mês
        this.filter.consolidated.periods[from].push(filter.periods);
        this.filter.consolidated.periods[from].push([
          `${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .format('YYYY-MM-[01] 00:00:00')}`,
          `${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .format('YYYY-MM')}-${dayjs(filter.periods[0])
            .subtract(1, 'month')
            .daysInMonth()} 23:59:59`,
        ]);
      }

      if (from !== 'default') {
        this.drawers.filter[from].close = !this.drawers.filter[from].close;
      }

      if (filter) {
        this.period[from] = filter.periods;
      }
      await this.search();
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      screenWidth: (state) => state.store.screenWidth,
      configurations: (state) => state.store.configurations,
    }),
    heatmapCenter() {
      if (
        this.configurations &&
        this.configurations.location &&
        this.configurations.location.geolocation
      ) {
        return [
          this.configurations.location.geolocation.latitude,
          this.configurations.location.geolocation.longitude,
        ];
      }
      return [-25.4573827, -49.2877663];
    },
  },
  watch: {
    heatmap: {
      deep: true,
      handler(newValue) {
        if (newValue.data.length >= 0) {
          this.showContent = true;
        }
      },
    },
  },
};
</script>

<style scoped>
.heat-map {
  height: 360px;
}
.msg-charts {
  display: none;
}
.content-loading {
  height: calc(100vh - 270px);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.top-negative {
  margin-top: -10px;
}
@media screen and (max-width: 991px) {
  .heat-map {
    touch-action: none;
    pointer-events: none;
  }
  @media screen and (orientation: portrait) {
    .heat-map,
    .chart {
      opacity: 0;
      position: absolute;
      top: 0;
      width: 0;
      overflow: hidden;
      padding: 0;
      margin: 0;
      z-index: -1;
    }
    .msg-charts {
      display: block;
    }
  }
}
</style>
